// Meta Pixel tracking utilities

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export const initMetaPixel = () => {
  if (typeof window === 'undefined') return

  // Initialize Meta Pixel
  ;(function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = true
    t.src = v
    s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq('init', '965958182359799')
  window.fbq('track', 'PageView')
}

export const trackAddToCart = (
  contentName: string,
  value: number,
  currency: string = 'USD',
) => {
  if (typeof window === 'undefined' || !window.fbq) return

  window.fbq('track', 'AddToCart', {
    content_name: contentName,
    content_type: 'product',
    value: value,
    currency: currency,
  })
}
